import Head from 'next/head'
import BookingHome from '@/components/TradlyHome/FleetHome'
import Header2 from '@/components/Header2'
import TradlyFooter from '@/partials/TradlyFooter'
import EnablingEntrepreneurs from '@/components/home/tradly-home/EnablingEntrepreneurs'
import DeveloperExperience from '@/components/home/tradly-home/DeveloperExperience'
import Opensource from '@/components/home/tradly-home/Opensource'
import BuildingBlocks from '@/components/home/tradly-home/BuildingBlocks/BuildingBlocks'
import Modularity from '@/components/home/tradly-home/Modularity'
import AnyDevices from '@/components/home/tradly-home/AnyDevices'
import Integrations from '@/components/home/tradly-home/Integrations'
import Studio from '@/components/home/tradly-home/Studio'
import Featuresstack from '@/components/home/tradly-home/Featuresstack'
import Cta from '@/partials/Cta'
import Onboarding_steps_bar from '@/partials/Onboarding_steps_bar'
import How from './_how.mdx'
import Features from './_bfeatures.mdx'
import Channel from './_channel.mdx'
import Checklist from './_checklist.mdx'

export default function Home() {
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Simple & Easy way to launch your booking Portal & Website & App"
        />
        <meta
          key="og:title"
          property="og:title"
          content="Simple & Easy way to launch your booking Portal & Website & App"
        />
        <title> Simple & Easy way to launch your booking Portal & Website & App</title>
      </Head>
      <div className="flex  flex-col min-h-screen overflow-hidden    ">
        <div className="flex-grow">
          <BookingHome />
          <div className=" max-w-6xl mx-auto pt-20 mb-20 space-y-20 overflow-hidden sm:pt-32 sm:mb-32 sm:space-y-32 md:pt-40 md:mb-40 md:space-y-40">
            <section className="text-center px-8">
              <h2 className="text-gray-900 text-4xl tracking-tight font-extrabold sm:text-5xl">
                “Idea into a Product is Hard in many layers”
              </h2>
              <figure>
                <blockquote>
                  <p className="mt-6 max-w-4xl mx-auto text-lg">
                    {/* I’ve written{' '}
                  <a
                    href="https://stories.jkbaseer.com"
                    className="text-color10 font-semibold"
                  >
                    a few stories
                  </a>{' '} */}
                    - Make your office or your time a productive one by improving the efficiency of
                    customer management. - Give your users an way to book activities or events
                    anytime they want.
                  </p>
                </blockquote>
              </figure>
            </section>
            <How />
            <EnablingEntrepreneurs />
            <Integrations />
            <AnyDevices />
            <Studio />
          </div>
          <Cta />

          <TradlyFooter />
        </div>
      </div>
    </>
  )
}
